export default {
    data() {
        return {
            panelBodyHack: false,
        };
    },
    mounted() {
        this.doPanelHack();

        window.addEventListener('resize', this.doPanelHack);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.doPanelHack);
    },
    methods: {
        doPanelHack() {
            if (this.panelHackTimer) {
                clearTimeout(this.panelHackTimer);
            }

            this.panelHackTimer = setTimeout(() => {
                this.panelBodyHack = true;
                setTimeout(() => {
                    this.panelBodyHack = false;
                }, 100);
            }, 100);
        },
    },
};
